import { createRouter, createWebHashHistory } from "vue-router";
import { routes } from "./routes.js";

const router = createRouter({
  // history: createWebHistory(),
  history: createWebHashHistory(),
  routes,
});

export default router;
